import React from "react";
import { Badge } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import MarkdownContent from "../../../moleculas/MarkdownContent";
import NewsAttachments from "../NewsAttachments";
import NewsGallery from "../NewsGallery";
import NewsVideo from "../NewsVideo";
import { NoticiaDetailVM } from "../../../../types/viewModels/cmsPublic";
import "./styles.scss";

export interface NewsDetailContentProps {
  noticia: NoticiaDetailVM;
}

const NewsDetailContent: React.FC<NewsDetailContentProps> = ({ noticia }) => {
  const { t } = useTranslation("news");

  return (
    <article className="w-100 news-detail">
      {noticia.imageUrl && (
        <img
          className="w-100 news-detail-hero mb-4"
          src={noticia.imageUrl}
          alt={noticia.title}
        />
      )}

      <h1>{noticia.title}</h1>

      <div className="d-flex flex-row flex-wrap align-items-center gap-2 mb-2">
        {noticia.publishedAtLabel && (
          <span className="news-detail-date" >
            {`${t("publishedOn")} `}
            <time dateTime={noticia.publishedAt}>
              {noticia.publishedAtLabel}
            </time>
          </span>
        )}
        {noticia.categories.map((category, position) => (
          <Badge
            key={`${category.slug}-${position}`}
            className="news-detail-badge"
          >
            {category.nombre || category.slug}
          </Badge>
        ))}
      </div>

      <hr className="custom-divider" />

      {noticia.summary && <p className="lead">{noticia.summary}</p>}

      <MarkdownContent content={noticia.content} />

      <NewsVideo
        title={noticia.title}
        embedUrl={noticia.videoEmbedUrl}
        originalUrl={noticia.videoOriginalUrl}
        file={noticia.videoFile}
      />

      <NewsGallery images={noticia.gallery} />

      <NewsAttachments files={noticia.attachments} />
    </article>
  );
};

export default NewsDetailContent;
